import { render, staticRenderFns } from "./QuoteItem.vue?vue&type=template&id=8f0b51f6&scoped=true&"
import script from "./QuoteItem.vue?vue&type=script&lang=js&"
export * from "./QuoteItem.vue?vue&type=script&lang=js&"
import style0 from "./QuoteItem.vue?vue&type=style&index=0&id=8f0b51f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0b51f6",
  null
  
)

export default component.exports